import React, { useEffect, useState } from 'react'
import useAxiosInstance from '../../hooks/useAxios';
import { toast } from 'react-toastify';
import { TableCustom } from '../../components/Table';
import { PENDING_REQUESTS_TABLE_COLUMNS } from '../../helper';

const PendingRequests = () => {
    const [loading, setLoading] = useState(false)
    const [response, setResponse] = useState([])
    const axiosInstance = useAxiosInstance()
    const handleDataUpdate = (page = null) => {
        setLoading(true);
        axiosInstance
            .get("/accounts/full_platform_pending_requests/")
            .then((res) => {
                setResponse(res.data.data)
                setLoading(false);
            })
            .catch((err) => {
                toast.error('Something went wrong!')
                setLoading(false);
            });
    }

    useEffect(() => {
        handleDataUpdate()
    }, [])
    return (
        <div className="h-screen overflow-y-auto mr-2">
            <p className="text-base font-semibold  my-2 px-2 py-2 bg-white rounded-lg border">
                Full platform pending requests
            </p>

            <TableCustom
                columns={PENDING_REQUESTS_TABLE_COLUMNS}
                data={{'data':response}}
                loading={loading}
                handleEdit={null}
                handleDelete={null}
                handleSelect={null}
                className="max-w-full"
            />  
        </div>
    )
}

export default PendingRequests